(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pdp-offers"] && !Shopify.designMode) return;
  try {
    class ClogCopyCode extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.onClick = this.copy.bind(this);
      this.button?.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
    }

    async copy() {
      const code = this.dataset.code || '';
      if (!code) return;

      try {
        await navigator.clipboard.writeText(code);
      } catch (error) {
        const input = document.createElement('textarea');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.position = 'absolute';
        input.style.left = '-9999px';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }

      this.classList.add('is-copied');
      this.button?.setAttribute('aria-label', `Copied discount code ${code}`);
      clearTimeout(this.resetTimer);
      this.resetTimer = setTimeout(() => {
        this.classList.remove('is-copied');
        this.button?.setAttribute('aria-label', `Copy discount code ${code}`);
      }, 2000);
    }
  }

  if (!customElements.get('clog-copy-code')) {
    customElements.define('clog-copy-code', ClogCopyCode);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-shipping-info"] && !Shopify.designMode) return;
  try {
    class ClogDeliveryCheck extends HTMLElement {
    connectedCallback() {
      this.openBtn = this.querySelector('[data-delivery-open]');
      this.closeBtn = this.querySelector('[data-delivery-close]');
      this.modal = this.querySelector('[data-delivery-modal]');
      this.form = this.querySelector('[data-delivery-form]');
      this.input = this.querySelector('input');
      this.result = this.querySelector('[data-delivery-result]');
      this.range = this.querySelector('[data-delivery-range]');
      this.pinOut = this.querySelector('[data-delivery-pin]');
      this.change = this.querySelector('[data-delivery-change]');
      this.titleEl = this.querySelector('[data-delivery-title]');
      this.subtitleEl = this.querySelector('[data-delivery-subtitle]');

      this.onOpen = () => this.openModal();
      this.onClose = () => this.closeModal();
      this.onSubmit = (event) => this.checkPincode(event);
      this.onChange = () => this.showForm();
      this.onBackdrop = (event) => {
        if (event.target === this.modal) this.closeModal();
      };

      this.openBtn?.addEventListener('click', this.onOpen);
      this.closeBtn?.addEventListener('click', this.onClose);
      this.form?.addEventListener('submit', this.onSubmit);
      this.change?.addEventListener('click', this.onChange);
      this.modal?.addEventListener('click', this.onBackdrop);
    }

    disconnectedCallback() {
      this.openBtn?.removeEventListener('click', this.onOpen);
      this.closeBtn?.removeEventListener('click', this.onClose);
      this.form?.removeEventListener('submit', this.onSubmit);
      this.change?.removeEventListener('click', this.onChange);
      this.modal?.removeEventListener('click', this.onBackdrop);
    }

    openModal() {
      if (this.pinOut?.textContent) {
        this.form.hidden = true;
        this.result.hidden = false;
      } else {
        this.showForm();
      }
      this.modal?.showModal();
      if (!this.result || this.result.hidden) this.input?.focus();
    }

    closeModal() {
      this.modal?.close();
    }

    showForm() {
      this.result.hidden = true;
      this.form.hidden = false;
      this.input?.focus();
    }

    checkPincode(event) {
      event.preventDefault();
      const pin = (this.input?.value || '').replace(/\D/g, '');

      if (pin.length !== 6) {
        this.input.setCustomValidity('Enter a 6-digit pincode');
        this.input.reportValidity();
        return;
      }

      this.input.setCustomValidity('');
      this.input.value = pin;
      this.pinOut.textContent = pin;
      this.range.textContent = this.deliveryRange();
      this.form.hidden = true;
      this.result.hidden = false;
      this.titleEl.textContent = `Pin ${pin}`;
      this.subtitleEl.textContent = this.range.textContent;
    }

    deliveryRange() {
      const start = new Date();
      const end = new Date();
      start.setDate(start.getDate() + 5);
      end.setDate(end.getDate() + 7);

      const format = (date) =>
        date.toLocaleDateString('en-IN', {
          weekday: 'short',
          day: 'numeric',
          month: 'short',
        });

      return `${format(start)} – ${format(end)}`;
    }
  }

  if (!customElements.get('clog-delivery-check')) {
    customElements.define('clog-delivery-check', ClogDeliveryCheck);
  }
  } catch(e) { console.error(e); }
})();

})();
